//
//
//
//
//
//
//
//
//
//
//

import AQModalDlg from "@/components/Generics/AQModalDlg/AQModalDlg";

export default {
    name: "QfMRichEditor",
    components: { AQModalDlg },
    props: {
        content: { type: String, default: "" }
    },
    data() {
        return {
            localShow: true,
            localContent: null,
            actions: [{ label: "Update", name: "set", disable: false }],
            toolbar: [
                [
                    "bold", "italic",
                    {
                        icon: "add",
                        fixedLabel: true,
                        list: "only-icons",
                        options: ["strike", "underline", "subscript", "superscript"]
                    }
                ],
                ["token", "hr", "link", "custom_btn"],
                ["fullscreen"],
                [
                    {
                        icon: this.$q.iconSet.editor.fontSize,
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: ["size-1", "size-2", "size-3", "size-4", "size-5", "size-6", "size-7"]
                    },
                    {
                        icon: this.$q.iconSet.editor.font,
                        fixedIcon: true,
                        list: "no-icons",
                        options: ["default_font", "arial", "arial_black", "comic_sans", "courier_new", "impact", "lucida_grande", "times_new_roman", "verdana"]
                    },
                    "removeFormat"
                ],
                ["quote", "unordered", "ordered"],
                [{
                    icon: this.$q.iconSet.editor.align,
                    fixedLabel: true,
                    list: "only-icons",
                    options: ["left", "center", "right", "justify"]
                }],
                ["undo", "redo"]
            ],
            fonts: {
                arial: "Arial",
                arial_black: "Arial Black",
                comic_sans: "Comic Sans MS",
                courier_new: "Courier New",
                impact: "Impact",
                lucida_grande: "Lucida Grande",
                times_new_roman: "Times New Roman",
                verdana: "Verdana"
            }
        };
    },
    watch: {
        content: {
            handler(val) {
                this.localContent = val || "";
            },
            immediate: true
        }
    },
    methods: {
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = action.detailed === "action_backdrop";
            } else if (action.simple === "action") {
                if (action.detailed === "set") {
                    this.$emit("update", this.localContent);
                    this.localShow = false;
                }
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        modalAfterShow() {
            this.$refs.editor.$refs.content.focus();
        }
    }
};
